import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import CommonDropdown from "../common/common_dropDown";
import uploadIcon from "../../assets/svg/upload_file.svg";
import closeAttachment from "../../assets/svg/close-red.svg";
import CommonStaticDropdown from "../common/common_static_dropdown";
import { submitVehicleFuelEntry, saveFuelAttachmentApi } from "./vehicle-api";

const FuelEntryModal = ({ show, id, lastKM, onHide, onSubmit }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const fileInputRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  // Form states
  const [vendor, setVendor] = useState(null);
  const [fuelType, setFuelType] = useState(null);
  const [currentKmFueling, setCurrentKmFueling] = useState("");
  const [lastKmFueling, setLastKmFueling] = useState(lastKM || "0");
  const [fuelQuantity, setFuelQuantity] = useState("");
  const [fuelPrice, setFuelPrice] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [attachmentPreview, setAttachmentPreview] = useState(null);

  const [errorMsg, setErrorMsg] = useState({
    vendor_id: "",
    fuel_type: "",
    current_km_fueling: "",
    last_km_fueling: "",
    fuel_quantity: "",
    fuel_price: "",
    total_amount: "",
    attachments: "",
  });

  // Fuel Type options (static list - can be replaced with API call)
  const fuelTypeOptions = [
    { label: "Diesel", value: "Diesel" },
    { label: "Petrol", value: "Petrol" },
    { label: "CNG", value: "CNG" },
    { label: "LPG", value: "LPG" },
  ];

  // Update lastKmFueling when lastKM prop changes
  useEffect(() => {
    setLastKmFueling(lastKM || "0");
  }, [lastKM]);

  // Calculate total amount (read-only)
  const totalAmount = fuelQuantity && fuelPrice ? (parseFloat(fuelQuantity) * parseFloat(fuelPrice)).toFixed(2) : "0.00";

  const validateForm = () => {
    const errors = {};
    if (!vendor) errors.vendor = "Vendor is required";
    if (!fuelType) errors.fuel_type = "Fuel Type is required";
    if (!currentKmFueling) errors.current_km_fueling = "Current KM is required";
    if (!lastKmFueling) errors.last_km_fueling = "Last KM is required";
    if (!fuelQuantity) errors.fuel_quantity = "Fuel Quantity is required";
    if (!fuelPrice) errors.fuel_price = "Fuel Price is required";
    setErrorMsg(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const newAttachments = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setAttachments([...attachments, ...newAttachments]);
    if (newAttachments.length > 0) {
      setAttachmentPreview(newAttachments[0].preview);
    }
  };

  const handleDragDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const newAttachments = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setAttachments([...attachments, ...newAttachments]);
    if (newAttachments.length > 0) {
      setAttachmentPreview(newAttachments[0].preview);
    }
  };

  const removeAttachment = (index) => {
    const newAttachments = attachments.filter((_, idx) => idx !== index);
    setAttachments(newAttachments);
    if (newAttachments.length === 0) {
      setAttachmentPreview(null);
    } else {
      setAttachmentPreview(newAttachments[0].preview);
    }
  };

  const handleSubmit = async () => {
    /*  if (!validateForm()) {
      return;
    } */

    const payload = {
      vendor_id: vendor?.value,
      fuel_type: fuelType?.value,
      current_km_fueling: currentKmFueling,
      last_km_fueling: lastKmFueling,
      fuel_quantity: fuelQuantity,
      fuel_price: fuelPrice,
      total_amount: totalAmount,
    };

    try {
      setIsLoading(true);
      payload.vehicle_id = id;
      // Call API to submit fuel entry for this vehicle
      console.log(payload);
      const response = await submitVehicleFuelEntry(payload);
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            vendor_id: "",
            fuel_type: "",
            current_km_fueling: "",
            last_km_fueling: "",
            fuel_quantity: "",
            fuel_price: "",
            total_amount: "",
            attachments: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        if (attachments.length === 0) {
          resetForm();
          onSubmit(response?.data);
        } else {
          saveAttachment(response.data.id);
        }
        /*  setTimeout(() => navigate(-1), 1500); */
      } else {
        onSubmit(response?.data);
      }
    } catch (err) {
      const errorMessages = err.response?.data?.errors || {};
      setErrorMsg((prev) => ({ ...prev, ...errorMessages }));
    } finally {
      setIsLoading(false);
    }
  };
  const saveAttachment = async (parentId) => {
    const fileToBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(file);
      });

    let imagesBase64 = [];
    try {
      imagesBase64 = await Promise.all(attachments.map((img) => fileToBase64(img.file)));
      const data = {
        attachment: imagesBase64,
      };
      const response = await saveFuelAttachmentApi(parentId, data);
      if (response.data.success === true) {
        resetForm();
        onSubmit(response?.data);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  };
  const resetForm = () => {
    // Reset all form fields
    setVendor(null);
    setFuelType(null);
    setCurrentKmFueling("");
    setLastKmFueling("");
    setFuelQuantity("");
    setFuelPrice("");
    setAttachments([]);
    setAttachmentPreview(null);
    setErrorMsg({});
  };

  const handleClose = () => {
    // Reset form on close
    resetForm();
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" size="md">
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="fw-700 fs-18">Add Fuel Cost</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "18px" }}>
        {/* Fuel Bunk Name - Full Width */}
        <div className="mb-3">
          <div className="d-flex flex-column align-items-start">
            <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Vendor</label>
            <CommonDropdown apiUrl={`${apiUrl}vendor/autosuggestion`} placeholder="Select" value={vendor} onSelect={setVendor} handleClear={() => setVendor(null)} style={{ width: "100%" }} />
            {errorMsg.vendor && <small className="text-danger mt-1">{errorMsg.vendor_id}</small>}
          </div>
        </div>

        {/* Location and Quantity Row */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="d-flex flex-column align-items-start">
              <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Fuel Type</label>
              <CommonStaticDropdown items={fuelTypeOptions} value={fuelType} onSelect={setFuelType} placeholder="Select" />
              {errorMsg.fuel_type && <small className="text-danger mt-1">{errorMsg.fuel_type}</small>}
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="d-flex flex-column align-items-start">
              <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Current KM while Fueling</label>
              <input type="text" className="form-control" placeholder="Enter here..." value={currentKmFueling} onChange={(e) => setCurrentKmFueling(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))} />
              {errorMsg.current_km_fueling && <small className="text-danger mt-1">{errorMsg.current_km_fueling}</small>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="d-flex flex-column align-items-start">
              <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Last KM while Fueling</label>
              <input type="text" className="form-control" placeholder="Enter here..." value={lastKmFueling} onChange={(e) => setLastKmFueling(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))} readOnly style={{ cursor: "not-allowed" }} />
              {errorMsg.last_km_fueling && <small className="text-danger mt-1">{errorMsg.last_km_fueling}</small>}
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="d-flex flex-column align-items-start">
              <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Quantity</label>
              <input type="text" className="form-control" placeholder="Enter here..." value={fuelQuantity} onChange={(e) => setFuelQuantity(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))} />
              {errorMsg.fuel_quantity && <small className="text-danger mt-1">{errorMsg.fuel_quantity}</small>}
            </div>
          </div>
        </div>
        {/* Price / Ltr and Total Price Row */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="d-flex flex-column align-items-start">
              <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Fuel Price</label>
              <input type="text" className="form-control" placeholder="Enter here..." value={fuelPrice} onChange={(e) => setFuelPrice(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))} />
              {errorMsg.fuel_price && <small className="text-danger mt-1">{errorMsg.fuel_price}</small>}
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="d-flex flex-column align-items-start">
              <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Total Amount</label>
              <input type="text" className="form-control" placeholder="0" value={totalAmount} readOnly style={{ backgroundColor: "#F5F5F5", cursor: "not-allowed" }} />
            </div>
          </div>
        </div>

        {/* Attachments */}
        <div>
          <div className="d-flex flex-column align-items-start">
            <label className="form-label fs-13 fw-600 text-start vehicle-label mb-2">Attachment</label>
            {errorMsg.fuel_price && <small className="text-danger mt-1">{errorMsg.attachments}</small>}
            <div
              className="rounded-3 p-4 d-flex align-items-center justify-content-center w-100"
              style={{
                height: 150,
                cursor: "pointer",
                border: "2px dashed #3469E7",
                backgroundColor: "#F8FAFF",
              }}
              onClick={() => fileInputRef.current?.click()}
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDragDrop}
            >
              {attachmentPreview ? (
                <img
                  src={attachmentPreview}
                  alt="preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <div className="text-center">
                  <img src={uploadIcon} alt="upload" className="mb-2" style={{ width: 40, height: 40 }} />
                  <p className="fs-13 fw-400 text-21272C mb-1">
                    Drag and drop or <strong className="text-3469E7">Select a file</strong>
                  </p>
                  <p className="text-gray fs-11 fw-400">You can add any type of files here.</p>
                </div>
              )}
            </div>

            {attachments.length > 0 && (
              <div className="d-flex flex-wrap gap-2 mt-3">
                {attachments.map((att, idx) => (
                  <div key={idx} className="position-relative" style={{ width: 80, height: 80 }}>
                    <img
                      src={att.preview}
                      alt={`thumb-${idx}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: 8,
                        cursor: "pointer",
                        background: "#F5F5F5",
                        border: "none",
                        padding: "4px",
                      }}
                      onClick={() => setAttachmentPreview(att.preview)}
                    />
                    <button
                      className="btn btn-sm position-absolute"
                      style={{
                        top: -8,
                        right: -8,
                        padding: "2px 6px",
                        fontSize: "10px",
                        borderRadius: "100px",
                        border: "1px solid #E5E5E5",
                        width: "21px",
                        height: "21px",
                        background: "#FFFFFF",
                      }}
                      onClick={() => removeAttachment(idx)}
                    >
                      <img src={closeAttachment} alt="close" />
                    </button>
                  </div>
                ))}
              </div>
            )}

            <input ref={fileInputRef} type="file" multiple onChange={handleFileUpload} style={{ display: "none" }} />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-top">
        <Button variant="outline-secondary" onClick={handleClose} className="rounded-pill px-4" style={{ borderColor: "#D4DDE7", color: "#212129" }}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} className="dark-purple-btn rounded-pill px-4 d-flex justify-content-center align-items-center" disabled={isLoading}>
          {isLoading ? <Spinner animation="border" size="sm" /> : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FuelEntryModal;
